import { calculateGrade, cn, getColorByScore } from "@/lib/utils";
import { MainCategoryResult } from "@/schema/assessment-results/MainCategoryResult";
import { TextBulletListSquare24Regular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";

interface AssessmentGroupListProps {
  result: MainCategoryResult;
}

export default function AssessmentGroupList({
  result,
}: AssessmentGroupListProps) {
  const { t } = useTranslation();

  return (
    <div>
      <div className="bg-cool-gray-100 flex flex-row items-center gap-x-[12px] px-[12px] py-[8px] border-t-[1px] border-cool-gray-200">
        <TextBulletListSquare24Regular />
        <span className="text-cool-gray-900 text-[14px] font-medium">
          {result.content}
        </span>
        <span className="text-cool-gray-500 text-[12px] font-medium ml-auto">
          {result.sub_category_results.length}{" "}
          {result.sub_category_results.length > 1
            ? t("sub-categories")
            : t("sub-category")}
        </span>
      </div>
      {result.sub_category_results.map((item, index) => {
        return (
          <div key={index} className="grid grid-cols-[max-content,1fr]">
            <div className="pl-[24px] overflow-hidden">
              <div className="w-[20px] h-[40%] bg-[transparent] border-l-[2px] border-b-[2px] rounded-bl-[16px] border-[#E3E4E5]" />
              {index != result.sub_category_results.length - 1 && (
                <div className="w-[20px] h-[100%] bg-[transparent] border-l-[2px] border-[#E3E4E5] mt-[-60%]" />
              )}
            </div>
            <div
              className={cn(
                "grid grid-cols-[200px,repeat(2,max-content),1fr] border-[#E3E4E5]",
                index != result.sub_category_results.length - 1 &&
                  "border-b-[1px]",
              )}
            >
              <div className="py-[16px] px-[24px]">
                <span className="text-cool-gray-700 text-[14px] leading-[20px] font-medium">
                  {item.content}
                </span>
              </div>
              <div className="py-[16px] px-[24px]">
                <div>
                  <span className="text-cool-gray-700 text-[14px] leading-[20px]  font-normal">
                    {t("score")}{" "}
                  </span>
                  <span className="text-cool-gray-700 text-[14px] leading-[20px]  font-bold">
                    {item.score ?? '--'}
                  </span>
                </div>
                <div>
                  <div className="bg-cool-gray-200 w-[100px] h-[8px] rounded-[8px]">
                    <div
                      className="bg-cyan-500 rounded-[8px] h-[8px]"
                      style={{
                        width: `${item?.score ?? 0}%`,
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="py-[16px] px-[24px]">
                <div>
                  <span className="text-cool-gray-500 text-[14px] leading-[20px] font-normal">
                    {t("judgement")}
                  </span>
                </div>
                <div className="flex justify-center items-center">
                  <span
                    className={cn(
                      getColorByScore(item.score),
                      "text-[14px] leading-[20px] font-bold text-center",
                    )}
                  >
                    {calculateGrade(item.score)}
                  </span>
                </div>
              </div>
              <div className="py-[16px] px-[24px]">
                <span className="text-cool-gray-700 text-[14px] leading-[20px] font-medium font-sans">
                  {item.evaluation_note}
                </span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
